import { render, staticRenderFns } from "./sitemap.vue?vue&type=template&id=5815822d"
import script from "./sitemap.vue?vue&type=script&lang=js"
export * from "./sitemap.vue?vue&type=script&lang=js"
import style0 from "./sitemap.vue?vue&type=style&index=0&id=5815822d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports